<template>
  <div class="container">
    <!--操作-->
    <el-button type="primary" plain size="small" round @click="handleAdd">新增人员</el-button>
    <!--搜索-->
    <search-filter :form-config="searchConfig" :model="query" @search="search" @reset="reset"></search-filter>
    <!--列表-->
    <el-table v-loading="loading" :data="tableData" 
      stripe border style="width: 100%" @row-dblclick="handleEdit">
      <el-table-column border label="序号" prop="id"></el-table-column>
      <el-table-column border label="登录账号" prop="account"></el-table-column>
      <el-table-column border label="人员名称" prop="employee_name"></el-table-column>
      <el-table-column border label="联系方式" prop="mobile"></el-table-column>
      <el-table-column border label="默认角色" prop="role"></el-table-column>
      <el-table-column border label="是否有效" prop="valid" :formatter="formatValid"></el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination style="margin-top:25px" @size-change="changePageSize" @current-change="changePage"
      :current-page.sync="pagination.current_page" :page-size="pagination.per_page"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    <!--对话框-->
    <el-dialog title="新增人员" :visible.sync="addModel.addShow" width="600px">
      <el-form ref="addForm" :model="addModel" label-width="80px" size="small">
        <el-form-item label="人员名称">
          <el-input v-model="addModel.employee_name" placeholder="人员名称"></el-input>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model="addModel.account" placeholder="登录账号"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="addModel.password" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="addModel.mobile" placeholder="联系方式"></el-input>
        </el-form-item>
        <el-form-item label="默认角色">
          <el-select v-model="addModel.role">
            <el-option v-for="item in searchConfig[3].list" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有效">
          <el-switch v-model="addModel.valid"></el-switch>
        </el-form-item>
        <el-form-item style="margin-left:80px;margin-top: 30px">
          <el-button type="primary" @click="onAdd">新增</el-button>
          <el-button type="info" @click="onAddClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑人员" :visible.sync="editModel.editShow" width="600px">
      <el-form ref="editForm" :model="editModel" label-width="80px" size="small">
        <el-form-item label="人员ID">
          <el-input v-model="editModel.id" disabled></el-input>
        </el-form-item>
        <el-form-item label="人员名称">
          <el-input v-model="editModel.employee_name" placeholder="人员名称"></el-input>
        </el-form-item>
        <el-form-item label="登录账号">
          <el-input v-model="editModel.account"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="editModel.password" placeholder="修改密码请写新密码，不修改密码则留空"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="editModel.mobile"></el-input>
        </el-form-item>
        <el-form-item label="默认角色">
          <el-select v-model="editModel.role">
            <el-option v-for="item in searchConfig[3].list" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有效">
          <el-switch v-model="editModel.valid"></el-switch>
        </el-form-item>
        <el-form-item style="margin-left:80px;margin-top: 30px">
          <el-button type="primary" @click="onEdit">编辑</el-button>
          <el-button type="info" @click="onEditClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      loading: false,
      currentConfig: {},
      tableData: [],
      pagination: { current_page: 1, total: 1, per_page: 10, },
      query: { employee_name2: "", account: "", mobile: "" },
      searchConfig: [
        { key: "employee_name2", label: "人员名称", type: "input" },
        { key: "account", label: "登录账号", type: "input" },
        { key: "mobile", label: "联系方式", type: "input" },
        {
          key: "role", label: "默认角色", type: "select", list: [
            { text: "主检", value: "主检" },
            { text: "检测员", value: "检测员" },
            { text: "审批人", value: "审批人" },
            { text: "审核人", value: "审核人" },
            { text: "记录员", value: "记录员" },
            { text: "告知书联系人", value: "告知书联系人" },
            { text: "项目观察员", value: "项目观察员" },
          ]
        },
      ],
      addModel: {
        addShow: false,
        employee_name: '',
        account: '',
        password: 'weizhongok888',
        mobile: '',
        role: '',
        valid: true
      },
      editModel: {
        editShow: false,
        id: '',
        employee_name: '',
        account: '',
        password: '',
        mobile: '',
        role: '',
        valid: true
      },
    };
  },
  computed: {
    ...mapGetters(['hasPermission']),
  },
  methods: {
    //是否有效 字段 转换
    formatValid(row, column) {
      return row.valid === '1' ? "是" : row.valid === '0' ? "否" : "否";
    },
    //初始化新增对话框
    initModel(modelType) {
      if (modelType === 'add') {
        this.addModel.addShow = false
        this.addModel.employee_name = ''
        this.addModel.account = ''
        this.addModel.password = 'weizhongok888'
        this.addModel.mobile = ''
        this.addModel.valid = true
      } else if (modelType === 'edit') {
        this.editModel.editShow = false
        this.editModel.id = ''
        this.editModel.employee_name = ''
        this.editModel.account = ''
        this.editModel.password = ''
        this.editModel.mobile = ''
      }
    },
    //新增
    handleAdd() {
      this.addModel.addShow = true
    },
    async onAdd() {
      try {
        let params = {
          new_employee_name: this.addModel.employee_name,
          account: this.addModel.account,
          password: this.addModel.password,
          mobile: this.addModel.mobile,
          role: this.addModel.role,
          valid: this.addModel.valid ? 1 : 0
        }
        await this.$Api.post('sys_employee', params)
        this.$message.success('新增成功')
        this.initModel('add')
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onAddClose() {
      this.initModel('add')
    },
    //编辑
    handleEdit(row) {
      this.editModel.editShow = true
      this.editModel.id = row.id
      this.editModel.employee_name = row.employee_name
      this.editModel.account = row.account
      this.editModel.mobile = row.mobile
      this.editModel.role = row.role
      this.editModel.valid = 1
    },
    async onEdit() {
      try {
        let params = {
          id: this.editModel.id,
          employee_name2: this.editModel.employee_name,
          account: this.editModel.account,
          password: this.editModel.password,
          mobile: this.editModel.mobile,
          role: this.editModel.role,
          valid: this.editModel.valid
        }
        await this.$Api.post('sys_employee_edit', params)
        this.$message.success('编辑成功')
        this.initModel('edit')
        await this.getList()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    onEditClose() {
      this.initModel('edit')
    },
    changePage() {
      this.getList();
    },
    changePageSize(size) {
      this.pagination.per_page = size;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.query = {
        employee_name2: "",
        account: "",
        mobile: "",
      };
      this.pagination.current_page = 1;
      this.pagination.total = 1;
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...this.query,
          ...this.pagination,
        };
        let data = await this.$Api.get("sys_employee", { params: params });
        if (data) {
          this.pagination = {
            current_page: data.current_page,
            total: data.total,
            per_page: data.per_page
          }
          this.tableData = data.data;
        }
        this.loading = false;
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.getList();
  },
};
</script>
